import { StayLength } from 'src/shared/types/stay-length';

import { parseMoveInDate } from './parse-move-in-date';

// Reads the stay from URL params, which must give either a duration or a move out date.
// Returns null when neither or both are given, or the one given is invalid.
export const getStayLength = (
    durationParam: string | null,
    moveOutDateParam: string | null
): StayLength | null => {
    if (durationParam && moveOutDateParam) {
        return null;
    }

    if (durationParam) {
        const duration = Number(durationParam);

        if (!Number.isInteger(duration) || duration <= 0) {
            return null;
        }

        return { duration };
    }

    if (moveOutDateParam) {
        // Accepts the same formats as the move in date and normalises to YYYY-MM-DD
        const moveOutDate = parseMoveInDate(moveOutDateParam);

        if (!moveOutDate) {
            return null;
        }

        return { moveOutDate };
    }

    return null;
};
